import { useEffect, useRef } from 'react';

export function useInViewObserver(ref, callback, options = {}) {
  const observer = useRef(null);

  useEffect(() => {
    if (ref.current) {
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            callback(entry);
          }
        });
      }, options);

      observer.current.observe(ref.current);
    }

    return () => {
      if (observer.current) observer.current.disconnect();
    };
  }, [ref, callback, options]);
}
